import React from 'react';
import PropTypes from 'prop-types';

import LineChart from 'components/LineChart';

const LineChartComponent = props =>
  <LineChart
    key="line-chart"
    nodes={props.nodes}
    paths={props.paths}
    ranges={props.ranges}
    graphTicks={props.graphTicks ? props.graphTicks : null}
  />;


LineChartComponent.propTypes = {
  nodes: PropTypes.array.isRequired,
  paths: PropTypes.array.isRequired,
  ranges: PropTypes.object.isRequired,
  graphTicks: PropTypes.array
};

export default LineChartComponent;
